module.exports = __webpack_public_path__ + "img/strategy.692e3393.svg";